import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7752a659"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cover" }
const _hoisted_2 = ["data-edit", "innerHTML"]

import { vMove, vInput, useCover } from './index';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };
const svg = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1194.894 1088.978">
  <defs>
    <linearGradient id="linear-gradient" x1="0.5" x2="1" y2="1.301" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="var(--theme-color-1-for-cover-10)"/>
      <stop offset="1" stop-color="#fff"/>
    </linearGradient>
  </defs>
  <g transform="translate(0 -523.087)">
    <path d="M2.457-1.721,8,0l.424,668.1-5.967,4.178Z" transform="matrix(0.574, -0.819, 0.819, 0.574, 679.363, 1243.475)" fill="var(--theme-color-1)"/>
    <path d="M-19839.016,5682.236l521.947,292.815 V5657Z" transform="translate(20535 -4445)" fill="url(#linear-gradient)"/>
    <path d="M-20535,5673.042l1191-510.351v324.146l-1191,313.337Z" transform="translate(20535 -4585)" fill="var(--theme-color-1)"/>
    <path d="M-20534.574,5479.838l1191.506-317.146v317.146l-1191.506,58.155Z" transform="translate(20535 -4266.258)" fill="var(--theme-color-1-for-cover-10)"/>
    <path d="M15481-12984.112v0h0v-3.253L16672-13492.913l0,3.259Z" transform="translate(-15481 14016)" fill="var(--theme-color-1)"/>
  </g>
</svg>
`;


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-cover-10',
  props: {
    useEdit: { type: Boolean },
    projectName: {},
    time: {},
    mainPageEnterpriseName: {},
    titlePosition: {},
    settleTimePosition: {},
    aspNamePosition: {},
    orderNumber: {},
    orderNumberPostion: {}
  },
  emits: ['posChange', 'valueChange'],
  setup(__props: any, { emit: __emit }) {

// import { hexToRgba } from '@/hooks/use-echart/utils';// FIXME:后台展示修改。一个小工具不需要全引用
const props = __props;

const emits = __emit;

const { info, onPosChange, onValueChange } = useCover(emits);

function hexToRgba(hex, opacity) {
  return (
    'rgba(' +
    parseInt('0x' + hex.slice(1, 3)) +
    ',' +
    parseInt('0x' + hex.slice(3, 5)) +
    ',' +
    parseInt('0x' + hex.slice(5, 7)) +
    ',' +
    opacity +
    ')'
  );
}

document.documentElement.style.setProperty(
  '--theme-color-1-for-cover-10',
  hexToRgba(
    document.documentElement.style.getPropertyValue('--theme-color-1'),
    0.8
  )
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info), (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        "data-edit": _ctx.useEdit,
        key: index,
        class: _normalizeClass(item.className),
        innerHTML: props[item.valueKey]
      }, null, 10, _hoisted_2)), [
        [_unref(vMove), {
        pos: props[item.posKey],
        change: (left, top) => _unref(onPosChange)(item.posKey, left, top)
      }],
        [_unref(vInput), {
        value: props[item.valueKey],
        change: (value) => _unref(onValueChange)(item.valueKey, value)
      }]
      ])
    }), 128)),
    _createElementVNode("div", {
      innerHTML: svg,
      class: "svg"
    })
  ]))
}
}

})